import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScExchangeCompointsModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  input:disabled {
    color: ${({ theme }) => theme.whiteColor};
  }

  & > .header {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;

    font-weight: 700;

    .title {
      font-size: 22px;
      line-height: 28px;
      letter-spacing: 0.22px;
      color: ${({ theme }) => theme.whiteColor};
    }

    .balance {
      font-size: 16px;
      line-height: 28px;
      letter-spacing: 0.16px;
      color: ${({ theme }) => theme.grayColor1};
    }
  }

  & > .warning {
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.grayColor6};

    color: ${({ theme }) => theme.whiteColor};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }

  .exchange-form {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .eqality {
      align-self: center;
    }

    .wager-inputs {
      display: grid;
      width: 100%;
      grid-template-columns: 1fr 120px;
      gap: 8px;
    }

    .exhange-form-input {
      display: flex;
      flex-direction: column;
      gap: 4px;

      & > .header {
        display: flex;
        height: 28px;
        padding: 0px 16px;

        font-size: 16px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0.16px;
        color: ${({ theme }) => theme.whiteColor};

        @media (max-width: 370px) {
          &.de {
            font-size: 13px;
          }
        }
      }
    }
  }

  .submit-btn {
    display: flex;
    justify-content: center;
    margin-top: 32px;

    button {
      min-width: 232px;
      width: fit-content;
    }

    @media (${device.mobileS}) {
      button {
        width: 100%;
      }
    }
  }
`;
